import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import { apiCallGetSurveyAnswersByVenue } from "../../../../Core/Apicall";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import moment from "moment";

export type QuickSurvey = {
  _id: string;
  userId: string;
  fullName: string;
  profileImagePath: string;
  createdAt: string;
  answers: {
    questionId: string;
    question: string;
    type: string;
    options: string[];
    answer: string;
    displayOrder: number;
  }[];
};

const QuickSurveySubmitted: React.FC<{ venueId: string }> = ({ venueId }) => {
  const [data, setData] = useState<QuickSurvey[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));
  const fetchData = async () => {
    try {
      setLoading(true);
      const payload = {
        venueId,
        offset: page,
        limit: rowsPerPage,
      } as any;
      const res = await apiCallGetSurveyAnswersByVenue(payload);
      setData(res.data);
      setTotalCount(res.totalCount);
    } catch (e: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [venueId, page, rowsPerPage]);
  const handlePageChange = (value: any) => {
    setPage(value);
  };
  return (
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
      {/* <Typography variant="h6" mb={2}>
        Quick Survey Responses
      </Typography> */}

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Submitted On</TableCell>
              <TableCell>Full Name</TableCell>
              <TableCell>Profile</TableCell>
              <TableCell>Survey Questions & Answers</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item) => (
              <TableRow key={item._id} hover>
                <TableCell sx={{ width: 150 }}>
                  {item.createdAt
                    ? moment(item.createdAt).format("DD-MMM-YYYY hh:mm A")
                    : "-"}
                </TableCell>
                <TableCell sx={{ width: 130 }}>{item.fullName}</TableCell>

                <TableCell sx={{ width: 130 }}>
                  <Avatar
                    src={item.profileImagePath}
                    alt={item.fullName}
                    sx={{ width: 50, height: 50 }}
                  />
                </TableCell>

                <TableCell>
                  <Stack spacing={1}>
                    {item.answers
                      .sort((a, b) => a.displayOrder - b.displayOrder)
                      .map((ans, idx) => (
                        <Stack key={ans.questionId + idx} spacing={0.5}>
                          <Typography variant="body2" fontWeight={500}>
                            {ans.question}
                          </Typography>
                          {ans.answer ? (
                            <Typography variant="body2" color="text.secondary">
                              Answer: {ans.answer}
                              {ans.type === "radio" && ans.options
                                ? ` (Options: ${ans.options.join(", ")})`
                                : ""}
                            </Typography>
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              Answer: N/A
                            </Typography>
                          )}

                          {idx !== item.answers.length - 1 && <Divider />}
                        </Stack>
                      ))}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {loading && <CommonShimmer />}
      </TableContainer>
      <EmptyData data={data} />
      <CommonPagination
        page={page}
        rowsPerPage={rowsPerPage}
        totalItems={totalCount}
        totalPages={totalPages}
        onPageChange={(value) => handlePageChange(value)}
        onRowsPerPageChange={(value) => {
          setRowsPerPage(value);
          setPage(1);
        }}
      />
    </Paper>
  );
};

export default QuickSurveySubmitted;
